import { Injector } from '@angular/core';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import {
  copyMask,
  isPointInLayer,
  pointsBetween,
  toMaskPosition,
} from '../../utils/mask-utils';
import { AbstractRasterDragHandler } from '../abstract-raster-drag-handler';
import { SuperpixelTool } from './superpixel-tool';

export class SuperpixelDragHandler extends AbstractRasterDragHandler {
  private tool: SuperpixelTool;

  constructor(code: number, initialEvent: MouseEvent, injector: Injector) {
    super(code, initialEvent, injector);
    this.tool = injector.get<SuperpixelTool>(SuperpixelTool);
  }

  onDrag(dragPoint: Point2D, lastPoint: Point2D) {
    const dragPath = pointsBetween(dragPoint, lastPoint);
    const newMask = this.paintSuperpixelsAlong(dragPath, this.code);
    this.store('rawMask').set(newMask);
  }

  protected override complete() {
    const batchValues = this.getBatchValues();
    this.shellConnector.pushAndTrack({
      ...this.event,
      tool: 'superpixel',
      ...batchValues.buildEventTrackingValue(),
    });
  }

  private paintSuperpixelsAlong(path: Point2D[], code: number) {
    const mask = copyMask(this.store.getRawMask());
    for (const point of path) {
      if (
        isPointInLayer(point, this.store.state().sensorRendererState) &&
        !this.alreadyPainted(point, code)
      ) {
        this.paintSuperpixelAt(point, code, mask);
      }
    }
    return mask;
  }

  private paintSuperpixelAt(point: Point2D, code: number, newMask: Uint8Array) {
    for (const position of this.tool.getPointsOfSuperpixelAt(point)) {
      newMask[position] = code;
    }
  }

  private alreadyPainted(point: Point2D, code: number) {
    const maskPosition = toMaskPosition(
      point,
      this.store.state().sensorRendererState,
    );
    return this.store.getRawMask()[maskPosition] === code;
  }
}
